export const SMALL_SCREEN_BREAKPOINT = 600;
export const MEDIUM_SCREEN_BREAKPOINT = 1200;
